module.exports = __webpack_public_path__ + "static/media/04-2520x1080-crop-1-q80.a1edaef6.jpg";